import SmoothScrollPolyfill from 'smoothscroll-polyfill';

SmoothScrollPolyfill.polyfill();

function makeClickHandler(hash) {
  return function(event) {
    event.preventDefault();
    document.querySelector(hash).scrollIntoView({ behavior: 'smooth' });
  };
}

const setup = () => {
  for (var i = 0; i < document.links.length; i++) {
    var link = document.links[i];
    if (link.hash && link.scrollIntoView && document.getElementById(link.hash.split('#')[1])) {
      link.addEventListener('click', makeClickHandler(link.hash));
    }
  }
};

export default {
  setup,
};



// WEBPACK FOOTER //
// ./assets/js/smooth-scroll.js